import script from "./Contact.vue?vue&type=script&lang=ts&setup=true"
export * from "./Contact.vue?vue&type=script&lang=ts&setup=true"

import "./Contact.vue?vue&type=style&index=0&id=1e0d0cfe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0d0cfe"]])

export default __exports__